<template>
  <div id="app">
    <Connecting v-if="GetConnectionStatus !== CONN.CONNECTED" />
    <Loading v-if="IsLoading" />
    <Login v-if="GetConnectionStatus === CONN.CONNECTED && !User" />
    <div class="app" v-if="GetConnectionStatus === CONN.CONNECTED && User">
      <div
        class="logs"
        v-if="GetAppInfo().Type === 'Test' && Object.keys(Logs).length > 0"
      >{{ Logs }}</div>
      <div class="toast" style="top:20px" v-if="ToastMessages.length">
        <div class="toast-header" v-for="(Message, Index) in ToastMessages" :key="Index">
          <strong class="mr-auto">{{ Message.Body }}</strong>
          <button
            type="button"
            class="ml-2 mb-1 close"
            data-dismiss="toast"
            aria-label="Close"
            @click="DeleteToastMessage(Index)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <b-navbar toggleable="md" type="dark" variant="dark">
        <b-navbar-brand to="/" class="logo">
          <img :src="require('@/assets/imgs/logo.png')" alt="ACK POS" />
          {{ User.StoreName }}
        </b-navbar-brand>
        <b-navbar-nav class="d-inline-block">
          <b-nav-item class="display-ib hidden-xs-down mr-3">
            <span>{{ User.Name }}</span>
            <i class="material-icons mifix ml-2">person</i>
          </b-nav-item>
          <b-nav-item
            class="d-inline-block mr-4"
            @click.prevent="() => { Logout(); return false; }"
          >
            <span>Kilitle</span>
            <i class="material-icons mifix ml-2">lock</i>
          </b-nav-item>
        </b-navbar-nav>
      </b-navbar>
      <div class="container-fluid mt-4" v-if="ErrorStatus || WarningStatus">
        <b-row>
          <b-col>
            <b-alert :show="ErrorStatus" variant="danger">
              <pre>{{ ErrorTextGUI }}</pre>
            </b-alert>
            <b-alert :show="WarningStatus" variant="warning">
              <pre>{{ WarningTextGUI }}</pre>
            </b-alert>
          </b-col>
        </b-row>
      </div>
      <router-view />
      <div class="copyright">ACK POS &copy; 2019</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Connecting from "./Pages/Connecting";
import Loading from "./Pages/Loading";
import Login from "./Pages/Login";
import { CONN } from "./Enums";
import { App } from "./Config";

export default {
  name: "App",
  components: {
    Connecting,
    Loading,
    Login
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("Connect");

    window.addEventListener("resize", this.HandleResize);

    this.HandleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.HandleResize);
  },
  computed: {
    CONN: () => CONN,
    ...mapGetters(["GetConnection", "GetConnectionStatus", "IsLoading"]),
    ...mapState([
      "User",
      "Logs",
      "AccessToken",
      "Loadings",
      "ErrorStatus",
      "ErrorText",
      "WarningStatus",
      "WarningText",
      "ToastMessages"
    ]),
    WarningTextGUI() {
      return this.WarningText === undefined
        ? ""
        : typeof this.WarningText === "object"
        ? JSON.parse(this.WarningText)
        : this.WarningText !== ""
        ? this.WarningText
        : "";
    },
    ErrorTextGUI() {
      return this.ErrorText === undefined
        ? ""
        : typeof this.ErrorText === "object"
        ? JSON.parse(this.ErrorText)
        : this.ErrorText !== ""
        ? this.ErrorText
        : "";
    }
  },
  methods: {
    HandleResize() {
      let WIW = window.innerWidth;
      let ScreenSize = "md";
      let ButtonSize = "lg";

      /*
        XS: MIN:     , MAX:  575,
        SM: MIN:  576, MAX:  767,
        MD: MIN:  768, MAX:  991,
        LG: MIN:  992, MAX: 1199,
        XL: MIN: 1200, MAX: 
      */

      if (WIW < 768) {
        ButtonSize = "sm";
      }

      if (WIW < 576) {
        ScreenSize = "xs";
      } else if (WIW < 768) {
        ScreenSize = "sm";
      } else if (WIW < 992) {
        ScreenSize = "md";
      } else if (WIW < 1200) {
        ScreenSize = "lg";
      } else {
        ScreenSize = "xl";
      }

      this.$store.dispatch("SetData", { Key: "ScreenWidth", Value: WIW });
      this.$store.dispatch("SetData", { Key: "ScreenSize", Value: ScreenSize });
      this.$store.dispatch("SetData", { Key: "ButtonSize", Value: ButtonSize });
    },
    ClearToastMessages() {
      this.$store.dispatch("ClearToastMessages");
    },
    DeleteToastMessage(ID) {
      this.$store.dispatch("DeleteToastMessage", ID);
    },
    Logout() {
      this.$store.dispatch("Logout");
    },
    GetAppInfo() {
      return App;
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>

<style>
.mifix {
  vertical-align: -6px;
}
.headless thead {
  display: none;
}
* {
  transition: none !important;
  outline: none !important;
  border-radius: 0 !important;
}
*:focus {
  outline: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
html,
body,
#app,
.app,
.splashscreen {
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: hidden;
  overflow-y: auto;
}
#app,
.app,
.splashscreen {
  display: block;
  position: relative;
}
span.logo {
  color: #c07513;
  font-size: 36px;
  letter-spacing: 4px;
  display: block;
  margin: 0 auto 20px;
  text-align: center;
  white-space: nowrap;
}
.splashscreen {
  overflow-x: hidden;
  background: #333;
  padding: 80px 0;
}
.splashscreen input::selection {
  background: yellow;
  color: transparent;
}
.splashscreen .row.main {
  height: 100%;
}
.connecting {
  color: #fff;
}
.splashscreen.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(50, 50, 50, 0.75);
  z-index: 9999;
  color: #fff;
}
#app .splashscreen.Login .form-control {
  border-radius: 0;
  border: 1px solid #3e3e3e;
  background: none;
  color: #c07513;
  font-weight: 900;
  text-transform: uppercase;
}
#app .splashscreen.Login textarea:focus,
#app .splashscreen.Login input:focus {
  outline: none;
  background: #444;
  border: 1px solid #c07513;
}
#app .splashscreen.Login .form-control.active {
  border: 1px solid #c07513;
}
#app .form-check-label {
  border: 1px solid #16a2b8;
  padding: 8px 16px;
}
#app .form-check.form-check-inline {
  margin-bottom: 10px;
}
.btn.btn-huge {
  width: 100%;
  min-height: 98px;
  padding: 24px 0;
  display: inline-grid;
  line-height: 24px;
  margin: 4px 0;
  cursor: pointer;
  text-align: center;
  font-size: 24px;
  box-sizing: border-box;
}
.payment-buttons .btn.btn-huge {
  min-height: 30px;
  height: 74px;
}
.payment-buttons .btn.btn-huge i {
  font-size: 32px;
}
.btn-huge {
  font-size: 16px;
}
.btn-huge i {
  font-size: 48px;
}
.btn-huge:active {
  background: #a2671b;
}
span.notifies {
  position: absolute;
  top: 1px;
  right: 1px;
  border-radius: 100% !important;
  padding: 0 8px;
  font-size: 13px;
}
#app .logo img {
  width: 32px;
  border: 1px solid #ba712b;
  margin-right: 6px;
}
#app .Login .logo {
  text-align: center;
  padding-bottom: 180px;
}
#app .Login .logo img {
  width: 180px;
  display: block;
  margin: 0 auto 32px;
}
#app .Login .logo span {
  font-size: 48px;
  display: block;
  color: #fff;
}
@media only screen and (max-width: 767px) {
  #app .Login .logo {
    text-align: center;
    padding-top: 20px;
    padding-bottom: 0;
    white-space: nowrap;
    vertical-align: middle;
    align-content: center;
    margin-bottom: 10px;
  }
  #app .Login .logo .flex {
    display: flex;
    margin: auto;
    width: min-content;
  }
  #app .Login .logo img {
    width: 48px;
    display: inline-block;
    border: 1px solid #744f24;
    margin: 0;
  }
  #app .Login .logo span {
    font-size: 24px;
    padding: 5px 14px 5px 12px;
    background: #2e2e2e;
    display: inline-block;
    border: 1px solid #744f24;
    border-left: none;
  }
}
#app .order-cart .list-group-item {
  border: none;
}
#app .table-link a.btn-huge {
  padding: 0;
}
#app .table-link .table-name {
  font-size: 24px;
}
#app .table-link .total-price {
  display: block;
  font-size: 14px;
  color: #999;
  white-space: nowrap;
}
#app .table-link a.btn-huge.btn-danger .total-price {
  color: #ffaab2;
}
#app .table-link a.btn-huge.btn-warning .total-price {
  color: #8a6700;
}
#app .table-link a.btn-huge.btn-secondary .total-price {
  color: #adadad;
}
#app .table-link a.btn-huge.btn-success .total-price {
  color: #b5e7c1;
}
#app .Kitchen .table-link a.btn-huge .total-price {
  color: #463400;
  font-size: 18px;
  line-height: 20px;
}
#app .d-block {
  width: 100%;
}
#app .weight-300 {
  font-weight: 300 !important;
}
#app .weight-400 {
  font-weight: 400 !important;
}
#app .weight-500 {
  font-weight: 500 !important;
}
#app .weight-600 {
  font-weight: 600 !important;
}
#app .weight-700 {
  font-weight: 700 !important;
}
#app .weight-900 {
  font-weight: 900 !important;
}
#app .order-quantity {
  font-weight: 300;
  padding: 2px 4px;
}
#app .amount {
  font-size: 42px;
  padding: 8px;
  height: auto;
  line-height: 0;
  color: #333;
  border: 1px solid #ddd;
  background: #eee;
}
#app .amount:focus {
  color: #000;
  background: #f8f8f8;
}
#app .top-buttons {
  white-space: nowrap;
}
#app td a.btn {
  white-space: nowrap;
}
#app .text-clock {
  font-size: 14px !important;
  color: #333 !important;
  display: inline-block !important;
}
#app .Kitchen .order {
  overflow: hidden;
}
#app .Kitchen .order.finished {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.2;
}
#app .selected-order {
  color: #fff !important;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}
#app .selected-order .text-muted {
  color: #fff !important;
}
#app .btn-success:active .text-muted {
  color: #fff !important;
}
.copyright {
  display: block;
  text-align: center;
  font-size: 10px;
  margin: 50px 10px 10px;
}
.p-t-40 {
  padding-top: 40px;
}
.m-l-5 {
  margin-left: 5px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-r-5 {
  margin-right: 5px;
}
.m-r-10 {
  margin-right: 10px;
}
.m-t-5 {
  margin-top: 5px;
}
.m-t-10 {
  margin-top: 10px;
}
.m-t-40 {
  margin-top: 40px;
}
.fs-9 {
  font-size: 9px !important;
}
.fs-10 {
  font-size: 10px !important;
}
.fs-11 {
  font-size: 11px !important;
}
.fs-12 {
  font-size: 12px !important;
}
.fs-13 {
  font-size: 13px !important;
}
.fs-14 {
  font-size: 14px !important;
}
.fs-15 {
  font-size: 15px !important;
}
.fs-16 {
  font-size: 16px !important;
}
.fs-17 {
  font-size: 17px !important;
}
.fs-18 {
  font-size: 18px !important;
}
.fs-24 {
  font-size: 24px !important;
}
.fs-27 {
  font-size: 27px !important;
}
.fs-32 {
  font-size: 32px !important;
}
.fs-36 {
  font-size: 36px !important;
}
.size-sm {
  font-size: 21px !important;
}
.size-lg {
  font-size: 48px !important;
}
.border-semilight {
  border-color: #e8e8e8 !important;
}
.badge-semilight {
  background-color: #f4f4f4 !important;
}
.btn-sm i.material-icons.semifix {
  vertical-align: -2px;
  font-size: 16px;
}
.ws-nowrap {
  display: inline-block;
  white-space: nowrap !important;
}
table.servers {
  border-bottom: 1px solid #eee;
}
table.servers tr td {
  vertical-align: middle;
}
table.serverline {
  width: 100%;
  width: 620px;
}
table.serverline td {
  padding: 4px;
}
table.serverline tr td:last-child {
  padding-right: 24px;
}
.toast {
  z-index: 1;
  background: #fff !important;
  position: absolute;
  top: 40px;
  right: 24px;
  opacity: 1 !important;
  width: 320px;
}
.formgroup {
  display: inline-block;
  width: 210px;
  padding: 12px !important;
  margin: 0 20px 0 0 !important;
}
@media only screen and (max-width: 767px) {
  .formgroup {
    width: 100%;
  }
}
.formgroup:hover {
  background: #fffbd4;
}
.formgroup legend {
  top: 18px;
  position: relative;
  margin: 12px 8px !important;
  display: block;
}
#app .SlimTDs .table td,
#app .SlimTDs .table th {
  padding: 4px 8px;
}
#app .toast-header {
  padding: 1rem 0.75rem;
}
#app .navbar-nav {
  right: 10px;
  position: absolute;
}
#app .display-ib {
  display: inline-block;
}
#app .ExtraOption {
  margin-right: 0;
  margin-left: 0;
  left: -15px;
  padding: 0;
}
#app .ExtraOption input {
  left: 24px;
  margin-right: 0;
  position: relative;
}
#app .ExtraOption label {
  padding: 8px 16px 8px 27px;
}
@media only screen and (max-width: 767px) {
  #app .toast {
    position: fixed;
    left: 0;
    top: 0 !important;
    width: 100%;
    max-width: none;
    padding: 2rem 0.75rem;
    z-index: 9;
  }
  #app .toast-header {
    display: block;
    width: 100%;
  }
  #app .toast-header:last-child {
    border-bottom: 0;
  }
}
#app button.close {
  padding: 10px;
}
.btn-servername {
  font-size: 15px;
  font-weight: 500;
}
.btn-top {
  margin-right: 10px;
  margin-bottom: 10px;
}
.btn-top:last-child {
  margin-right: 0;
}
.bindingsform {
  height: 443px;
}
.bindings {
  height: 320px;
  overflow: hidden;
  overflow-y: auto;
}
.bindings .custom-control {
  white-space: nowrap;
  display: block;
  border-bottom: 1px solid #eee;
}
.bindings .custom-control-label {
  cursor: pointer;
}
.bindings .custom-control:hover {
  background: #f8f8f8;
}
.strike {
  text-decoration: line-through;
}
table.options tr td {
  padding: 2px 10px;
}
.color-primary {
  color: #007bff;
}
.color-secondary {
  color: #6c757d;
}
.color-light {
  color: #f8f9fa;
}
.color-dark {
  color: #343a40;
}
.color-success {
  color: #28a745;
}
.color-info {
  color: #17a2b8;
}
.color-warning {
  color: #e88b00;
}
.color-danger {
  color: #dc3545;
}
/*
  XS: MIN:     , MAX:  575,
  SM: MIN:  576, MAX:  767,
  MD: MIN:  768, MAX:  991,
  LG: MIN:  992, MAX: 1199,
  XL: MIN: 1200, MAX: 
*/
@media only screen and (max-width: 575px) {
  .hidden-xs-down {
    display: none !important;
  }
}
@media only screen and (max-width: 767px) {
  .hidden-sm-down {
    display: none !important;
  }
}
@media only screen and (max-width: 991px) {
  .hidden-md-down {
    display: none !important;
  }
}
@media only screen and (max-width: 1199px) {
  .hidden-lg-down {
    display: none !important;
  }
}
@media only screen and (min-width: 576px) {
  .hidden-sm-up {
    display: none !important;
  }
}
@media only screen and (min-width: 768px) {
  .hidden-md-up {
    display: none !important;
  }
}
@media only screen and (min-width: 992px) {
  .hidden-lg-up {
    display: none !important;
  }
}
@media only screen and (min-width: 1200px) {
  .hidden-xl-up {
    display: none !important;
  }
}
</style>
